import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import Member from '@src/data/member'
import { Subtitle1 } from '@src/elements/typography/typography'
import { convertToLocalDate } from '@src/util/date-format'

@Component
export class ScheduledDeactivationDateCell extends Vue {
  @Prop({ required: true })
  item: Member

  goToDeactivationSection () {
    if (!this.item.scheduledDeactivationDate) return
    this.$router.push({
      path: `/trainers/platform/members/${this.item.id}/account`,
      hash: '#deactivation'
    })
  }

  render (h: CreateElement) {
    const date = this.item.scheduledDeactivationDate
    return <div class={{ 'cell': true, 'scheduled-deactivation-date-cell': true, 'clickable': !!date }}
                onClick={this.goToDeactivationSection}>
      <Subtitle1>{date ? convertToLocalDate(date) : ''}</Subtitle1>
    </div>
  }
}
